import { useApi } from '@/composables/useApi'
import {
  db, ref, push, serverTimestamp, child, update, set,
} from '@/libs/firebase'

const api = useApi()

export default {
  namespaced: true,
  state: {
    refNotifications: '/notifications',
    refNotificationUser: '',
    refNotificationNotRead: 'notification_not_read',
    notifications: [],
    allNotifications: [],
  },
  getters: {
    getRefNotifications(state) {
      return state.refNotifications
    },
    getNotifications(state) {
      return state.notifications
    },
    getRefNotificationNotRead(state) {
      return state.refNotificationNotRead
    },
    getRefNotificationUser(state) {
      return state.refNotificationUser
    },
    getNotificationsUser(state) {
      return state.notifications
    },
    getAllNotifications(state) {
      return state.allNotifications
    },
  },
  mutations: {
    setNotifications(state, payload) {
      state.notifications = `/${payload}`
    },
    setNotificationUser(state, payload) {
      state.refNotificationUser = `${state.refNotifications}/${payload}`
    },
    setNotificationsUser(state, payload) {
      state.notifications = payload
    },
    setAllNotifications(state, payload) {
      state.allNotifications = payload
    },
  },
  actions: {
    setNotReadNotifications({ state, commit }, payload) {
      commit('setNotificationUser', payload)
      let updateds = {}
      state.notifications.forEach((notification, key) => {
        if (notification.notification_not_read) {
          updateds = {
            ...updateds,
            [notification.key]: {
              ...notification,
              notification_not_read: false,
            },
          }
        }
      })
      update(ref(db, state.refNotificationNotRead), { [payload]: false})
      update(ref(db, state.refNotificationUser), updateds)
    },
    sendNotifications({ state, commit, dispatch }, { titulo, descricao, id_user, type, link, target, evento, metadata }) {
      commit('setNotificationUser', id_user)

      const data = {
        titulo,
        id_user,
        descricao,
        type,
        notification_not_read: true,
        date: serverTimestamp(),
        link: link || '',
        target: target || false,
        evento: evento || '',
        metadata: metadata || null,
      }

      const newKey = push(child(ref(db), state.refNotificationUser)).key
      const updates = {}
      data.key = newKey
      updates[`/${newKey}`] = data
      update(ref(db, state.refNotificationNotRead), { [id_user]: true })
      update(ref(db, state.refNotificationUser), updates)
    },
    setNotificationsReadByKey({ state, commit }, { id_user, key }) {
      const refNotificationUser = ref(db, `/notifications/${id_user}/${key}`)
      update(refNotificationUser, { ...state.allNotifications[key], notification_not_read: false })
    },
    primeiraCobranca({ commit }, { id, data }) {
      return new Promise((resolve, reject) => {
        api.post(`/pagamentos/primeira-cobranca/${id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    segundaCobranca({ commit }, { id, data }) {
      return new Promise((resolve, reject) => {
        api.post(`/pagamentos/segunda-cobranca/${id}`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    bloqueiaUsuario({ commit }, payload) {
      return new Promise((resolve, reject) => {
        api.post(`/pagamentos/bloqueia-usuario/${payload.id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    resertStoreNotifications({ commit }) {
      commit('setNotificationsUser', [])
      commit('setNotificationUser', '')
    },
  },
}
